import React from 'react';
import { Add as AddIcon } from '@mui/icons-material';
import { Box, Typography, Button } from '@mui/material';

const PageHeader = ({
  title,
  subtitle,
  btnText,
  onBtnClick,
  btnIcon = <AddIcon />,
  titleIcon
}) => {
  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      mb: 5,
      flexWrap: 'wrap',
      gap: 1,
      position: 'relative'
    }}>
      <Box sx={{ flex: 1, minWidth: '300px' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2, mb: .5 }}>
          {titleIcon && React.cloneElement(titleIcon, {
            sx: {
              color: 'var(--accent-gold)',
              fontSize: '2rem',
              ...titleIcon.props.sx
            }
          })}
          <Typography
            variant="h4"
            className="page-title"
            sx={{
              mb: 0,
              fontFamily: 'var(--primary-serif) !important',
              fontSize: '1.85rem',
              fontWeight: 600,
              color: 'var(--header-title)'
            }}
          >
            {title}
          </Typography>
        </Box>
        <Typography
          variant="body1"
          className="page-subtitle"
          sx={{
            mb: 2.5,
            color: 'var(--subtitle-text)',
            fontSize: '0.9rem'
          }}
        >
          {subtitle}
        </Typography>
      </Box>
      {btnText && (
        <Button
          variant="contained"
          onClick={onBtnClick}
          sx={{
            bgcolor: 'var(--premium-dark)',
            color: 'white',
            textTransform: 'uppercase',
            fontSize: '0.75rem',
            letterSpacing: '0.1em',
            fontWeight: 800,
            borderRadius: '10px',
            pl: 0.8,
            pr: 2.5,
            py: 0.8,
            mt: 0.5,
            '&:hover': {
              bgcolor: 'hsl(222 47% 18%)',
              boxShadow: '0 6px 20px rgba(0,0,0,0.15)'
            },
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
            transition: 'all 0.3s ease',
            display: 'flex',
            alignItems: 'center',
            gap: 1.5
          }}
        >
          <Box sx={{
            bgcolor: 'rgba(255, 255, 255, 0.1)',
            borderRadius: '6px',
            p: 0.8,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            {React.cloneElement(btnIcon, { sx: { fontSize: '1.1rem', color: 'var(--accent-gold)' } })}
          </Box>
          {btnText}
        </Button>
      )}
      <Box sx={{ position: 'relative', width: '100%' }}>
        <Box sx={{ width: '100%', height: '1px', bgcolor: 'var(--border-light)', position: 'absolute', bottom: 0 }} />
        <Box sx={{ width: 100, height: '3px', bgcolor: 'var(--accent-gold)', position: 'absolute', bottom: -1, left: 0 }} />
      </Box>
    </Box>
  );
};

export default PageHeader;
